import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router'
import styled from 'styled-components'
import { DrawerBodyWrapper, TOAST_TYPE } from '@base'
import { Table } from '@baseV2'
import { strings } from '@constants'
import { getEntityHistoryVersions } from '@data'
import { showToast } from '@data/state/action'
import { toggleDrawer } from '@data/state/action/root'
import { paths } from '@routes'

const BodyWrapper = styled.div`
	display: flex;
	flex-direction: column;
`

const ROWS_PER_PAGE = 10

// Response shape is not confirmed yet: accept a bare array or a wrapped list
const getHistoryRows = (res) => {
	const list = Array.isArray(res) ? res : res?.data || res?.versions || res?.content || []
	// newest version first
	return Array.isArray(list)
		? list.map((item, index) => ({ ...item, _version: item?.version ?? index + 1 })).sort((a, b) => b._version - a._version)
		: []
}

// Entity page for a history row, with the version in the query string
const getVersionLink = (entityType, referenceId, version) => {
	const basePath =
		entityType === 'Enquiry' ? paths.admin_manage_enquiry_manage_details(referenceId) : paths.admin_manage_enquiry_order_edit(referenceId)
	return `${basePath}?version=${version}`
}

const historyColumns = [
	{ label: 'Version', key: '_version', mobile: true },
	{ label: 'Changes', key: (row) => row?.paths?.length || '--', mobile: true },
]

// Shared by the Order and Enquiry journey drawers
export const HistoryTable = ({ entityType, referenceId, refreshKey }) => {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const [loading, setLoading] = useState(true)
	const [historyList, setHistoryList] = useState([])
	const [page, setPage] = useState(0)

	useEffect(() => {
		setLoading(true)
		getEntityHistoryVersions(entityType, referenceId)
			.then((res) => {
				setHistoryList(getHistoryRows(res))
				setPage(0)
			})
			.catch((e) => {
				console.log(e)
				dispatch(showToast(true, strings('journey_not_found'), { type: TOAST_TYPE.ERROR }))
			})
			.finally(() => setLoading(false))
	}, [dispatch, entityType, referenceId, refreshKey])

	// The newest version is the live data, so it can't be opened as a snapshot
	const latestVersion = historyList[0]?._version

	// Full row click opens that version and closes the drawer
	const rowClickHandler = (row) => {
		if (row._version === latestVersion) return
		dispatch(toggleDrawer(false))
		navigate(getVersionLink(entityType, referenceId, row._version))
	}

	const changePageHandler = (next = true) => {
		setPage((prev) => (next ? prev + 1 : Math.max(prev - 1, 0)))
	}

	return (
		<Table
			data={historyList.slice(page * ROWS_PER_PAGE, (page + 1) * ROWS_PER_PAGE)}
			columns={historyColumns}
			loading={loading}
			rowsToDisplay={ROWS_PER_PAGE}
			totalItemCount={historyList.length}
			page={page}
			onPageChange={changePageHandler}
			onRowClick={rowClickHandler}
			isRowDisabled={(row) => row._version === latestVersion}
			hideFooter={true}
		/>
	)
}

const Index = ({ journeySourceId }) => {
	return (
		<DrawerBodyWrapper>
			<BodyWrapper>
				<HistoryTable entityType='Order' referenceId={journeySourceId} />
			</BodyWrapper>
		</DrawerBodyWrapper>
	)
}

export default Index
